import { render, staticRenderFns } from "./FormUserGroup.vue?vue&type=template&id=4ff71130&"
import script from "./FormUserGroup.vue?vue&type=script&lang=js&"
export * from "./FormUserGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports